import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';

import RenderCard from '~/Nova/scenes/HostingList/components/RenderCard';
import AdvancedHostingResetPasswordModal from '~/scenes/Hosting/scenes/HostingDetail/components/AdvancedHosting/components/ResetPassword/ResetPasswordModal';
import AdvancedHostingServerStatusModal from '~/scenes/Hosting/scenes/HostingDetail/components/AdvancedHosting/components/Server/ServerStatusModal';

interface RootPasswordProps {
  hostingPlanId: string;
  serverStatus: string;
}

const RootPassword: React.FC<RootPasswordProps> = ({
  hostingPlanId,
  serverStatus,
}) => {
  const { t } = useTranslation('hosting', { keyPrefix: 'hostingNova' });
  const isServerOnline = serverStatus === 'active';
  const [openPasswordResetModal, setOpenPasswordResetModal] = useState(false);
  const [openServerStatusSuccessModal, setOpenServerStatusSuccessModal] =
    useState(false);
  const [showResetPasswordSuccessTxt, setShowResetPasswordSuccessTxt] =
    useState(false);

  const handleOpenModal = () => {
    setOpenPasswordResetModal(true);
  };

  const handleResetPasswordSuccess = () => {
    setShowResetPasswordSuccessTxt(true);
    setOpenServerStatusSuccessModal(true);
  };

  const handleSuccessfullModalClose = () => {
    setOpenServerStatusSuccessModal(false);
    setShowResetPasswordSuccessTxt(false);
  };

  return (
    <>
      <RenderCard
        title={t('rootPassword.title')}
        action={
          <Button
            size="small"
            variant="text"
            onClick={handleOpenModal}
            disabled={!isServerOnline}
          >
            {t('rootPassword.resetPassBtn')}
          </Button>
        }
        dataTestId="root-password-card"
      />

      <AdvancedHostingResetPasswordModal
        openPasswordResetModal={openPasswordResetModal}
        setOpenPasswordResetModal={setOpenPasswordResetModal}
        showResetPasswordSuccessModal={handleResetPasswordSuccess}
        hostingPlanId={hostingPlanId}
      />

      <AdvancedHostingServerStatusModal
        openServerStatusSuccessModal={openServerStatusSuccessModal}
        handleSuccessfullModalClose={handleSuccessfullModalClose}
        showResetPasswordSuccessTxt={showResetPasswordSuccessTxt}
      />
    </>
  );
};

export default RootPassword;
